import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { TextImage } from '../../templates';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class LearnTestExportView extends Component {

	render () {
		const {
			content,
			heading,
			imageToRight,
		} = this.props.content.landingPage.learnTestExport;

		return (
			<TextImage
				{...{
					content,
					heading,
					imageToRight,
				}}
				imageClassName='LearnTestExportView'
			/>
		);
	}

}

export default withLanguageContext(LearnTestExportView);



// WEBPACK FOOTER //
// ./src/components/views/LearnTestExportView/LearnTestExportView.js